import { useState } from "react";
import { Drum, Piano, Waves, Zap } from "lucide-react";
import { DrumMachine } from "./DrumMachine";
import { Keyboard } from "./Keyboard";
import { Knob } from "../mixer/Knob";

const TABS = [
  { id: "drums", label: "Drum machine", icon: Drum },
  { id: "keys", label: "Keys", icon: Piano, octave: 3 },
  { id: "bass", label: "Synth bass", icon: Waves, octave: 1 },
  { id: "lead", label: "Lead synth", icon: Zap, octave: 4 },
];

export const InstrumentsPanel = ({ inst, canPlay, liveConnected, channelLabel }) => {
  const [tab, setTab] = useState("drums");
  const [vol, setVol] = useState(0.9);
  const cur = TABS.find((t) => t.id === tab);
  const changeVol = (v) => { setVol(v); inst.out.gain.setTargetAtTime(v, inst.ctx.currentTime, 0.03); };
  return (
    <section className="panel p-4" data-testid="instruments-panel">
      <div className="flex flex-wrap items-center gap-2">
        <span className="mono-label text-yellow-300 mr-2">Instruments</span>
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`instrument-tab-${t.id}`}
            className={`flex items-center gap-1.5 rounded-[3px] border px-3 py-1.5 text-xs font-semibold transition-colors ${tab === t.id ? "border-yellow-400 bg-yellow-400/10 text-yellow-300" : "border-zinc-800 text-zinc-400 hover:text-white"}`}>
            <t.icon className="h-3.5 w-3.5" /> {t.label}
          </button>
        ))}
        <div className="ml-auto flex items-center gap-3">
          <span className="mono text-[10px] text-zinc-500 max-w-[260px] text-right" data-testid="instruments-route-note">
            {!canPlay ? "Go on stage to play for the room" : liveConnected ? `Room hears you on ${channelLabel}` : "Only you hear this until live video connects"}
          </span>
          <Knob label="Vol" value={vol} onChange={changeVol} testId="instruments-volume-knob" />
        </div>
      </div>
      <div className={`mt-4 ${canPlay ? "" : "opacity-50 pointer-events-none"}`}>
        {tab === "drums" ? <DrumMachine inst={inst} disabled={!canPlay} />
          : <Keyboard key={tab} inst={inst} kind={tab} baseOctave={cur.octave} disabled={!canPlay} active={canPlay} />}
      </div>
    </section>
  );
};
